import React from 'react';
import imgURL from './img/photo.png';
class ImgCard extends React.Component {
    constructor(props) {
        super(props);
        this.revealDefaultImage = this.revealDefaultImage.bind(this)
        this.state = {
            reveal: false,
        }
    }
    revealDefaultImage() {
        this.setState({
            reveal: true
        })
    }
    render() {
        const { src } = this.props
        const { status } = this.state
        if (!src || this.state.reveal) {
            return (
                <img src={imgURL}/>
            )
        }
        return (
            <img src={src} onError={this.revealDefaultImage}/>
        )
    }
}
export default ImgCard;